import React, { createContext, useReducer, useEffect } from 'react';

import {
  nowPlayingReducer,
  SET_EPISODE,
  SET_PLAY_STATUS
} from '../reducers/now-playing.reducer';

export const NowPlayingContext = createContext();

const initialState = {
  nowPlaying: JSON.parse(localStorage.getItem('lastPlayed')),
  isPlaying: false
};

const NowPlayingProvider = ({ children }) => {
  const [nowPlayingState, dispatch] = useReducer(
    nowPlayingReducer,
    initialState
  );

  useEffect(() => {
    localStorage.setItem(
      'lastPlayed',
      JSON.stringify(nowPlayingState.nowPlaying)
    );
  }, [nowPlayingState.nowPlaying]);

  const setEpisode = episode => {
    dispatch({ type: SET_EPISODE, payload: episode });
  };

  const setPlaying = isPlaying => {
    dispatch({ type: SET_PLAY_STATUS, payload: isPlaying });
  };

  return (
    <NowPlayingContext.Provider
      value={{
        nowPlaying: nowPlayingState.nowPlaying,
        isPlaying: nowPlayingState.isPlaying,
        setEpisode,
        setPlaying
      }}
    >
      {children}
    </NowPlayingContext.Provider>
  );
};

export default NowPlayingProvider;
